/* eslint-disable react/jsx-props-no-spreading */
import { Box, Button, styled } from '@mui/material';
import { FormProvider, Controller, useForm } from 'react-hook-form';
import { appVersionsApi  } from '@Store/api/appVersionsSlice';
import FormInput from 'UI/Form/FormInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { yupResolver } from '@hookform/resolvers/yup';
import { useWatch } from 'react-hook-form';
import { useEffect } from 'react';

import { schema } from './CreateAppVersionForm.validation';
import { toast } from 'react-toastify';

const FormContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 25px;

  & .MuiFormHelperText-root {
    color: red !important;
  }
`;

interface IProps {
  handleClose: () => void;
  onSuccess: () => void;
}

const { useCreateAppVersionMutation } = appVersionsApi;


export function CreateAppVersionForm({ handleClose, onSuccess }: IProps) {
  const [createAppVersion] = useCreateAppVersionMutation();

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      platform: 1,
      versionTag: '',
      policyType: 1,
    },
  });

  const { handleSubmit, register, control } = methods;

  const selectedPlatform = useWatch({
    control,
    name: 'platform',
  });
  const platform = useWatch({ control, name: 'platform' });
  const policyType = useWatch({ control, name: 'policyType' });
  const { setValue } = methods;

  useEffect(() => {
    if (platform === 2 && policyType === 2) {
      setValue('policyType', 1);
    }
  }, [platform, policyType, setValue]);

  const onSubmit = async (data: any) => {
    const payload = {
      Platform: Number(data.platform), 
      VersionTag: data.versionTag,
      PolicyType: Number(data.policyType), 
    };

    try {
      await createAppVersion(payload).unwrap();
      toast.success('App version created successfuly');

      onSuccess?.();
      handleClose();
    } catch (e) {
      toast.error('Failed to create app version');
    }
  };

  return (
    <FormProvider {...methods}>
      <FormContainer component="form" onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="platform"
          control={control}
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel id="select-platform-label">Select Platform</InputLabel>
              <Select {...field} required labelId="select-platform-label" label="Select Platform">
                <MenuItem value={1}>Android</MenuItem>
                <MenuItem value={2}>iOS</MenuItem>
              </Select>
            </FormControl>
          )}
        />

        <FormInput label="App Version" {...register('versionTag')}/>
        
        <Controller
          name="policyType"
          control={control}
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel id="select-type-label">Select Type</InputLabel>
              <Select {...field} required labelId="select-type-label" label="Select Type">
                <MenuItem value={1}>Optional</MenuItem>
                {selectedPlatform === 1 && <MenuItem value={2}>Flexible</MenuItem>}
                <MenuItem value={3}>Immediate</MenuItem>
              </Select>
            </FormControl>

          )}
        />

        <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
          Add Version
        </Button>
      </FormContainer>
    </FormProvider>
  );
}